import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

// Patient Pages
import LoginPage from '../pages/LoginPage';
import PatientsPage from '../pages/Patient/PatientsPage';
import PatientCreatePage from '../pages/Patient/PatientCreatePage';
import PatientDetailPage from '../pages/Patient/PatientDetailPage';
import PatientEditPage from '../pages/Patient/PatientEditPage';

// Study Pages
import StudyListPage from '../pages/Study/StudyListPage';
import StudyCreatePage from '../pages/Study/StudyCreatePage';
import StudyDetailPage from '../pages/Study/StudyDetailPage';
import StudyEditPage from '../pages/Study/StudyEditPage';

// DICOM Pages
import DICOMListPage from '../pages/DICOM/DICOMListPage';
import DICOMCreatePage from '../pages/DICOM/DICOMCreatePage';
import DICOMDetailPage from '../pages/DICOM/DICOMDetailPage';
import DICOMEditPage from '../pages/DICOM/DICOMEditPage';

// Labels Pages
import LabelListPage from '../pages/FSALabels/LabelListPage';
import LabelCreatePage from '../pages/FSALabels/LabelCreatePage';
import LabelDetailPage from '../pages/FSALabels/LabelDetailPage';
import LabelEditPage from '../pages/FSALabels/LabelEditPage';

// SegmAnno Labels Pages
import SegmAnnoLabelListPage from '../pages/SegmAnnoLabels/SegmAnnoLabelListPage';
import SegmAnnoLabelCreatePage from '../pages/SegmAnnoLabels/SegmAnnoLabelCreatePage';
import SegmAnnoLabelDetailPage from '../pages/SegmAnnoLabels/SegmAnnoLabelDetailPage';
import SegmAnnoLabelEditPage from '../pages/SegmAnnoLabels/SegmAnnoLabelEditPage';

const AppRoutes = () => {
  // Pull token from AuthContext (not from localStorage)
  const { token } = useContext(AuthContext);

  const PrivateRoute = ({ children }) => {
    return token ? children : <Navigate to="/login" replace />;
  };

  const PublicRoute = ({ children }) => {
    return token ? <Navigate to="/patients" replace /> : children;
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />

        {/* Patients */}
        <Route
          path="/patients"
          element={
            <PrivateRoute>
              <PatientsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/patients/create"
          element={
            <PrivateRoute>
              <PatientCreatePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/patients/:id"
          element={
            <PrivateRoute>
              <PatientDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/patients/:id/edit"
          element={
            <PrivateRoute>
              <PatientEditPage />
            </PrivateRoute>
          }
        />

        {/* DICOM */}
        <Route
          path="/dicoms"
          element={
            <PrivateRoute>
              <DICOMListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dicoms/create"
          element={
            <PrivateRoute>
              <DICOMCreatePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dicoms/:id"
          element={
            <PrivateRoute>
              <DICOMDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dicoms/:id/edit"
          element={
            <PrivateRoute>
              <DICOMEditPage />
            </PrivateRoute>
          }
        />

        {/* Study */}
        <Route
          path="/studies"
          element={
            <PrivateRoute>
              <StudyListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/studies/create"
          element={
            <PrivateRoute>
              <StudyCreatePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/studies/:id"
          element={
            <PrivateRoute>
              <StudyDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/studies/:id/edit"
          element={
            <PrivateRoute>
              <StudyEditPage />
            </PrivateRoute>
          }
        />

        {/* Labels */}
        <Route
          path="/fsa_labels"
          element={
            <PrivateRoute>
              <LabelListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/fsa_labels/create"
          element={
            <PrivateRoute>
              <LabelCreatePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/fsa_labels/:id"
          element={
            <PrivateRoute>
              <LabelDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/fsa_labels/:id/edit"
          element={
            <PrivateRoute>
              <LabelEditPage />
            </PrivateRoute>
          }
        />

        {/* SegmAnno Labels */}
        <Route
          path="/segm_anno_labels"
          element={
            <PrivateRoute>
              <SegmAnnoLabelListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/segm_anno_labels/create"
          element={
            <PrivateRoute>
              <SegmAnnoLabelCreatePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/segm_anno_labels/:id"
          element={
            <PrivateRoute>
              <SegmAnnoLabelDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/segm_anno_labels/:id/edit"
          element={
            <PrivateRoute>
              <SegmAnnoLabelEditPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/"
          element={token ? <Navigate to="/patients" replace /> : <Navigate to="/login" replace />}
        />

        <Route path="*" element={<h2>404 Not Found</h2>} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
